module.exports = __webpack_public_path__ + "img/the-wall.ee33e625.jpg";